/**
 * Utils: Back-end
 */

import config from "../config";
import { getSession } from "./helpers";

/**
 * Register a new user
 */
export const userRegister = async (email, password) => {
  return await requestApi("/users/register", "POST", { email, password });
};

/**
 * Login a new user
 */
export const userLogin = async (email, password) => {
  return await requestApi("/users/login", "POST", { email, password });
};

/**
 * userGet
 */
export const userGet = async (token) => {
  return await requestApi("/user", "POST", null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getOrganizations = async () => {
  const { organizations } = await requestApi("/organizations", "GET");
  return organizations;
};

export const getBricksForOrganization = async (organization) => {
  const { brickCollections } = await requestApi(
    `/organizations/${organization}/brickCollections`,
    "GET"
  );
  return brickCollections;
};

export const getBrickCollection = async (organization, collection) => {
  const { brickCollection } = await requestApi(
    `/organizations/${organization}/brickCollections/${collection}`,
    "GET"
  );
  return brickCollection;
};

/**
 * Request presigned uploads. The API picks each key; files is a list of
 * { collection, contentType, kind: "brick" | "thumbnail" }.
 */
export const requestUploads = async (files) => {
  const { uploads } = await requestApi(
    `brickCollections/bricks/uploadRequest`,
    "POST",
    { files }
  );
  return uploads;
};

export const createBrickCollection = async (organization, params) => {
  const { brickCollection } = await requestApi(
    `/organizations/${organization}/brickCollections`,
    "POST",
    params
  );
  return brickCollection;
};

export const updateBrickCollection = async (organization, id, params) => {
  const { brickCollection } = await requestApi(
    `/organizations/${organization}/brickCollections/${id}`,
    "POST",
    params
  );
  return brickCollection;
};

/**
 * API request to call the backend
 */
export const requestApi = async (
  path = "",
  method = "GET",
  data = null,
  headers = {}
) => {
  // Check if API URL has been set
  if (!config?.domains?.api) {
    throw new Error(
      `Error: Missing API Domain – Please add the API domain from your serverless Express.js back-end to this front-end application.  You can do this in the "./config.js" file.  Instructions are listed there and in the documentation.`
    );
  }

  // Prepare URL
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }
  const url = `${config.domains.api}${path}`;

  // Set headers
  const token = getSession()?.userToken;
  headers = Object.assign(
    { "Content-Type": "application/json" },
    token ? { Authorization: `Bearer ${token}` } : {},
    headers
  );

  // Default options are marked with *
  const response = await fetch(url, {
    method: method.toUpperCase(),
    mode: "cors",
    cache: "no-cache",
    headers,
    body: data ? JSON.stringify(data) : null,
  });

  if (response.status < 200 || response.status >= 300) {
    const error = await response.json();
    throw new Error(error.error);
  }

  return await response.json();
};
